import {
  AsyncAutoCompleteFieldProps,
  AsyncODataDropdownFieldProps,
  utils,
} from "@ucl/library";
import { Predicate, Query } from "@syncfusion/ej2-data";

export interface TaskTypeAsyncAutoCompleteProps {
  apiBaseUrl: string;
  getAuthRequestHeader: () => Promise<Record<string, string> | undefined>;
  entityType?: string;
}

export const taskTypeAsyncAutoCompleteConfig: (
  props: TaskTypeAsyncAutoCompleteProps
) => AsyncAutoCompleteFieldProps = ({
  apiBaseUrl,
  getAuthRequestHeader,
  entityType,
}) => ({
  label: "Task Template",
  sortBy: "taskTemplateName",
  // odataUrl: `${utils.strings.trimEndForwardSlashForURL(apiBaseUrl)}/odata/bolttasktemplateodata`,
  baseODataUrl: `${utils.strings.trimEndForwardSlashForURL(apiBaseUrl)}/odata`,
  oDataKey: "bolttasktemplateodata",
  suffixODataUrl: entityType
    ? `?$filter=(entityType eq '${entityType}' or entityType eq null)`
    : "",
  getAuthRequestHeader: getAuthRequestHeader,
  fieldNames: ["id", "taskTemplateName"],
  autoCompleteSettings: {
    fields: { text: "taskTemplateName", value: "id" },
    query: new Query()
      .where("isDeleted", "equal", false)
      .select(["id", "taskTemplateName"])
      .sortBy("taskTemplateName")
      .take(50),
    itemTemplate: "${taskTemplateName}",
  },
});

export const taskTypeAsyncODataDropdownConfig: (
  props: TaskTypeAsyncAutoCompleteProps
) => AsyncODataDropdownFieldProps = ({
  apiBaseUrl,
  getAuthRequestHeader,
  entityType,
}) => {
  let predicate = new Predicate("isDeleted", "equal", false);
  if (entityType) {
    predicate = predicate.and(new Predicate("entityType", "equal", `${entityType}`).or(new Predicate("entityType", "equal", null)));
  }

  return {
    label: "Task Template",
    odataUrl: `${utils.strings.trimEndForwardSlashForURL(apiBaseUrl)}/odata/bolttasktemplateodata`,
    getAuthRequestHeader: getAuthRequestHeader,
    textColumnName: "taskTemplateName",
    valueColumnName: "id",
    predicate,
    take: 50,
    sortByColumnName: "taskTemplateName",
  };
};
